import { RouteObject } from 'react-router-dom';
import HomePage from '@/pages/home/page';
import IndustriesPage from '@/pages/industries/page';
import CaseStudiesPage from '@/pages/case-studies/page';
import ContactPage from '@/pages/contact/page';
import NotFound from '@/pages/NotFound';

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/industries', element: <IndustriesPage /> },
  { path: '/case-studies', element: <CaseStudiesPage /> },
  { path: '/contact', element: <ContactPage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
